import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['tipo', 'ano', 'mes']

    limparFormulario() {
        this.tipoTarget.value = ''
        this.anoTarget.value = ''
        this.mesTarget.value = ''

        // limpa o hidden input que o React cria
        const hiddenUsuarioId = document.querySelector('input[name="executado_por"]')
        if (hiddenUsuarioId) hiddenUsuarioId.value = ''

        const form = document.getElementById('form-filtro-gerador-relatorios')
        window.location.href = form.action
    }
}
